var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSms({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20.1496H7.5C4.8 20.1496 3 18.7996 3 15.6496V9.34961C3 6.19961 4.8 4.84961 7.5 4.84961H16.5C19.2 4.84961 21 6.19961 21 9.34961V15.6496C21 18.7996 19.2 20.1496 16.5 20.1496Z",
    stroke: "black",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.79883L13.683 12.0488C12.756 12.7868 11.235 12.7868 10.308 12.0488L7.5 9.79883",
    stroke: "black",
    strokeWidth: 1.35,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.8fa41619422f442ba46f8c697196b399.svg";
export { ForwardRef as ReactComponent };